/**
 * 数据加载状态组件
 */
import React from 'react'
import './index.less'

export function LoadStatus(props: { icon: boolean, title: string ,className:string}) {
  return (
    <div className={`${props.className??""}`}>
      {props.icon ? 
        <>
          <span className="icon-loading"></span>{props.title}
        </>
       : 
        <>{props.title}</>
      }
    </div>
  )
}